// Helper function to convert Firebase error codes to user-friendly messages
export const getFirebaseErrorMessage = (error: any): string => {
  if (!error || !error.code) {
    return error?.message || 'An unexpected error occurred. Please try again.';
  }

  switch (error.code) {
    case 'auth/invalid-credential':
    case 'auth/user-not-found':
    case 'auth/wrong-password':
      return 'Invalid email or password. Please check your credentials and try again.';
    
    case 'auth/user-disabled':
      return 'This account has been disabled. Please contact support for assistance.';
    
    case 'auth/too-many-requests':
      return 'Too many failed login attempts. Please try again later or reset your password.';
    
    case 'auth/email-already-in-use':
      return 'ACCOUNT_EXISTS:An account with this email already exists.';
    
    case 'auth/weak-password':
      return 'Password is too weak. Please choose a stronger password with at least 6 characters.';
    
    case 'auth/invalid-email':
      return 'Please enter a valid email address.';
    
    case 'auth/missing-password':
      return 'Password is required. Please enter your password.';
    
    case 'auth/network-request-failed':
      return 'Network error. Please check your internet connection and try again.';
    
    case 'auth/operation-not-allowed':
      return 'This operation is not allowed. Please contact support.';
    
    case 'auth/requires-recent-login':
      return 'Please log in again to complete this action for security purposes.';
    
    case 'auth/email-change-needs-verification':
      return 'Please verify your new email address to complete the change.';
    
    case 'auth/invalid-verification-code':
      return 'Invalid verification code. Please check and try again.';
    
    case 'auth/expired-action-code':
      return 'This verification link has expired. Please request a new one.';
    
    default:
      // For any other Firebase errors, provide a generic message
      return 'Authentication failed. Please try again or contact support if the problem persists.';
  }
};

// Helper for general API errors
export const getApiErrorMessage = (error: any): string => {
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }
  
  if (error?.message) {
    // Check if it's a Firebase error first
    if (error.code && error.code.startsWith('auth/')) {
      return getFirebaseErrorMessage(error);
    }
    return error.message;
  }
  
  return 'An unexpected error occurred. Please try again.';
};